import { Grid, LinearProgress, LinearProgressProps, Select } from '@mui/material';
import { withStyles } from '@mui/styles';
import { HSpacer, RoutalPalette, RoutalTooltip } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

import Text from '../../../react-components/Text';

export const NotificationsHeaderContainer = styled.div`
  max-height: 117px;
  background-color: ${RoutalPalette.neutral02n};
  border-bottom: 1px solid ${RoutalPalette.neutral10};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

interface LinearProgressWithLabelProps extends LinearProgressProps {
  classes: {
    colorPrimary: string;
    barColorPrimary: string;
  };
  used: number;
  total: number;
}

const barStyles = {
  colorPrimary: {
    backgroundColor: `transparent`,
    border: `1px solid ${RoutalPalette.primary40}`,
  },
  barColorPrimary: {
    backgroundColor: `${RoutalPalette.primary40}`,
  },
};

const getSubscriptionEmailsUsage = (usedEmails: number, totalEmails: number): number => {
  return (usedEmails / totalEmails) * 100;
};

export const LinearProgressWithLabel = withStyles(barStyles)(
  ({ classes, used, total }: LinearProgressWithLabelProps) => {
    let value = getSubscriptionEmailsUsage(used, total);
    value = value <= 100 ? value : 100;
    return (
      <RoutalTooltip
        placement="bottom"
        title={
          <Text
            intlId="projects.communication.messages.emails.usage"
            intlValues={{
              used,
              total,
            }}
          />
        }
        backgroundColor={RoutalPalette.primary40n}
      >
        <Grid container direction="row" wrap="nowrap" alignItems="center">
          {value ? (
            <>
              <Grid item>
                <Text variant="label">{`${Math.round(value)}%`}</Text>
              </Grid>
              <HSpacer small />
            </>
          ) : null}
          <Grid item style={{ width: `100%` }}>
            <LinearProgress
              variant="determinate"
              value={value}
              style={{ height: `12px`, borderRadius: `50px` }}
              classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }}
            />
          </Grid>
        </Grid>
      </RoutalTooltip>
    );
  }
);

export const PodSelect = styled(Select)`
  width: 200px;
  .MuiSelect-select {
    padding: 8px;
  }
`;
